import { Label } from 'src/components/label';
import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor width="100%" height="100%" src={`/assets/icons/navbar/${name}.svg`} />
);

export const navData = [
  {
    title: 'Trang chủ',
    path: '/',
    icon: icon('ic-analytics'),
  },
  {
    title: 'Thông tin khách hàng',
    path: '/company-info',
    icon: icon('ic-user'),
  },
  {
    title: 'Báo cáo phát thải khí nhà kính',
    path: '/company-report',
    icon: icon('co2-svgrepo-com'),
  },
  {
    title: 'Quản lý chứng từ liên quan',
    path: '/company-document',
    icon: icon('report-linechart-svgrepo-com'),
  },
  {
    title: 'Thông tin liên hệ',
    path: '/contact',
    icon: icon('contact-details-filled-svgrepo-com'),
  }
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic-disabled'),
  // },
];
